<script setup>

import { ref } from "vue";
import CartaoListaDeDados from "./ListaDeDados/CartaoListaDeDados.vue";
import VisualizarDadosNotaFiscalEmitidaModal from "./VisualizarDadosNotaFiscalEmitida/VisualizarDadosNotaFiscalEmitidaModal.vue";
import VisualizarDadosContaAReceberAvulsaModal from "./VisualizarDadosContaAReceberAvulsa/VisualizarDadosContaAReceberAvulsaModal.vue";
import GerarRecebimentosModal from "./GerarRecebimentos/GerarRecebimentosModal.vue";
import VincularNotaFiscalEmitidaModal from "./VincularNotaFiscalEmitida/VincularNotaFiscalEmitidaModal.vue";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore();

//==================================================================//
//============= Visualizando Dado Nota Fiscal Emitida ==============//
//==================================================================//

const visualizandoDadoNotaFiscalEmitida = ref(false);

//==================================================================//
//========= Visualizando Dado Conta a Receber Avulsa ===============//
//==================================================================//

const visualizandoDadoContaAReceberAvulsa = ref(false);

//==================================================================//
//==================== Gerando Recebimentos ========================//
//==================================================================//

const gerandoRecebimentos = ref(false);

//==================================================================//
//==================== Vincular Nota Fiscal ========================//
//==================================================================//

const vincularNotaFiscal = ref(false);

//==================================================================//
//====================== Controles Desativados =====================//
//==================================================================//

const controlesDesativados = ref(false);

//==================================================================//
//============================= Dados ==============================//
//==================================================================//

const dados = ref([]);
const dado = ref({});

//==================================================================//
//===================== Contas Financeiras =========================//
//==================================================================//

const contasFinanceiras = ref([]);

//==================================================================//
//================== Notas Fiscais Vinculaveis =====================//
//==================================================================//

const notasFiscaisVinculaveis = ref([]);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    controlesDesativados.value = update;

};

//==================================================================//
//======================== Altera Dado =============================//
//==================================================================//

const alteraDados = (update=[])=>{

    dados.value = update;

};

//==================================================================//
//======================= Altera Dado ==============================//
//==================================================================//

const alteraDado = (update={})=>{

    dado.value = update;

};

//==================================================================//
//================== Altera Contas Financeiras =====================//
//==================================================================//

const alteraContasFinanceiras = (update=[])=>{

    contasFinanceiras.value = update;

};

//==================================================================//
//============== Altera Notas Fiscais Vinculaveis ==================//
//==================================================================//

const alteraNotasFiscaisVinculaveis = (update=[])=>{

    notasFiscaisVinculaveis.value = update;

};

//==================================================================//
//======== Altera Visualizando Dado Nota Fiscal Emitida ============//
//==================================================================//

const alteraVisualizandoDadoNotaFiscalEmitida = (update={})=>{

    alteraDado(update?.dado);
    visualizandoDadoNotaFiscalEmitida.value = update.visualizandoDadoNotaFiscalEmitida;

};

//==================================================================//
//========== Altera Visualizando Conta a Receber Avulsa ============//
//==================================================================//

const alteraVisualizandoDadoContaAReceberAvulsa = (update={})=>{

    alteraDado(update?.dado);
    visualizandoDadoContaAReceberAvulsa.value = update.visualizandoDadoContaAReceberAvulsa;

};

//==================================================================//
//================ Altera Gerando Recebimentos =====================//
//==================================================================//

const alteraGerandoRecebimentos = (update={})=>{

    alteraDado(update?.dado);
    gerandoRecebimentos.value = update.gerandoRecebimentos;
   
};

//==================================================================//
//================= Altera Vicular Notas Fiscal ====================//
//==================================================================//

const alteraVincularNotaFiscal = (update={})=>{

    alteraDado(update?.dado);
    vincularNotaFiscal.value = update.vincularNotaFiscal;
   
};

</script>

<template>

    <main
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <div class="c-main__header">

            <h2 class="c-main__titulo">
                Contas a Receber
            </h2>
            
        </div>

        <CartaoListaDeDados
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :controlesDesativados="controlesDesativados"
            :visualizandoDadoNotaFiscalEmitida="visualizandoDadoNotaFiscalEmitida"
            :visualizandoDadoContaAReceberAvulsa="visualizandoDadoContaAReceberAvulsa"
            :gerandoRecebimentos="gerandoRecebimentos"
            :vincularNotaFiscal="vincularNotaFiscal"
            :dados="dados"
            :dado="dado"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraVisualizandoDadoNotaFiscalEmitida="alteraVisualizandoDadoNotaFiscalEmitida"
            @update:alteraVisualizandoDadoContaAReceberAvulsa="alteraVisualizandoDadoContaAReceberAvulsa"
            @update:alteraGerandoRecebimentos="alteraGerandoRecebimentos"
            @update:alteraVincularNotaFiscal="alteraVincularNotaFiscal"
            @update:alteraDados="alteraDados"
            @update:alteraContasFinanceiras="alteraContasFinanceiras"
            @update:alteraNotasFiscaisVinculaveis="alteraNotasFiscaisVinculaveis"
        ></CartaoListaDeDados>
        
        <VisualizarDadosNotaFiscalEmitidaModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :visualizandoDadoNotaFiscalEmitida="visualizandoDadoNotaFiscalEmitida"
            :dadoOriginal="dado"
            @update:alteraVisualizandoDadoNotaFiscalEmitida="alteraVisualizandoDadoNotaFiscalEmitida"
        ></VisualizarDadosNotaFiscalEmitidaModal>

        <VisualizarDadosContaAReceberAvulsaModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :visualizandoDadoContaAReceberAvulsa="visualizandoDadoContaAReceberAvulsa"
            :dadoOriginal="dado"
            @update:alteraVisualizandoDadoContaAReceberAvulsa="alteraVisualizandoDadoContaAReceberAvulsa"
        ></VisualizarDadosContaAReceberAvulsaModal>

        <GerarRecebimentosModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :controlesDesativados="controlesDesativados"
            :gerandoRecebimentos="gerandoRecebimentos"
            :contasFinanceiras="contasFinanceiras"
            :dadoOriginal="dado"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraGerandoRecebimentos="alteraGerandoRecebimentos"
        ></GerarRecebimentosModal>

        <VincularNotaFiscalEmitidaModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :controlesDesativados="controlesDesativados"
            :vincularNotaFiscal="vincularNotaFiscal"
            :notasFiscaisVinculaveis="notasFiscaisVinculaveis"
            :dadoOriginal="dado"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraVincularNotaFiscal="alteraVincularNotaFiscal"
        ></VincularNotaFiscalEmitidaModal>

    </main>

</template>

<style scoped>

/*==================================================================*/
/*============================ Main ================================*/
/*==================================================================*/

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

/*==================================================================*/
/*======================== Main Header =============================*/
/*==================================================================*/

.c-main__header{
    display: flex;
    justify-content: space-between;
}

</style>